import React from "react";
import RadioOptions from "./RadioOptions";
import autoBind from 'react-autobind';
import {Row, Col} from 'react-bootstrap'
import '../Styling/templateBuilder.css'

class OptionSelector extends React.Component{
	constructor(props){
		super(props);

		this.state = {
			tables: [],
			intent: ["Retrieve", "Create", "Update", "CreateOrUpdate", "Delete"],
			format: ["CSV", "JSON", "XPath"],
			commit: ["True", "False"],
			script: ["True", "False"],
			intentValue: "Retrieve",
			formatValue: "CSV",
			commitValue: "True",
			scriptValue: "False"

		};
		autoBind(this);

	}

	populateTables(newVals, chosenTable){
		let dropdown = document.getElementById("tablesDropDown");
		dropdown.innerHTML = "";
		let defOption = document.createElement("option");
		defOption.text = "choose a table";
		defOption.value = "";
		defOption.selected = true;
		defOption.disabled = true;
		defOption.hidden = true;
		dropdown.appendChild(defOption);
		let tableOptions = newVals;
		for (let i = 0; i < tableOptions.length; i++){
			let opt = tableOptions[i];
			let element = document.createElement("option");
			if (opt.tableName === chosenTable){
				defOption.selected = false;
				element.selected = true;
			}
			element.text = opt.tableName;
			element.value = JSON.stringify(opt);
			dropdown.appendChild(element);
		}
	}

	componentWillReceiveProps(nextProps){
		this.setState({
			tables: nextProps.tables
		});
		this.populateTables(nextProps.tables, nextProps.chosenTable);
	}

	tableUpdate(){
		this.props.onTableChange(document.getElementById("tablesDropDown").value)
	}
	nameUpdate(){
		this.props.onNameChange(document.getElementById("nameEntry").value);
	}

	changeIntent(intent){
		this.props.onIntentChange(intent);
		this.setState({
			intentValue: intent
		})
	}

	changeFormat(format){
		this.props.onFormatChange(format);
		this.setState({
			formatValue: format
		})
	}

	changeCommit(commit){
		this.props.onCommitChange(commit);
		this.setState({
			commitValue: commit
		})
	}

	scriptChange(script){
		this.scriptOptionVisibility(script);
		this.props.onScriptChange(script);
		this.setState({
			scriptValue:script
		})
	}

	scriptOptionVisibility(script){
		document.getElementById("script-types").style.visibility = script === 'False' ? "hidden" : "visible";
	}

	updateScriptOptions(script, value){
		if (script === "All" && value === true){
			let buttons = document.getElementsByClassName("script-type-option");
			for (let i = 0; i < buttons.length; i++){
				if (buttons[i].id !== "All"){
					buttons[i].checked = false;
					this.props.onScriptSelectionChange(buttons[i].id, false)
				}
			}
		}
		if (script !== "All" && value === true){
			let buttons = document.getElementsByClassName("script-type-option");
			for (let i = 0; i < buttons.length; i++){
				if (buttons[i].id === "All"){
					buttons[i].checked = false;
					this.props.onScriptSelectionChange(buttons[i].id, false);
					break;
				}
			}
		}
		this.props.onScriptSelectionChange(script, value)
	}

	render(){
		return(
			<div className="optionSelector" id="option-selector" style={{flex:'1'}}>
				<Row className="category" id="table">
					<Col md={2}>
						<label form="tablesDropDown">Table:</label>
					</Col>
					<Col>
						<select id="tablesDropDown" onChange={() => this.tableUpdate()} defaultValue={"choose a table"}>
							<option>choose a table</option>
						</select>
					</Col>

				</Row>
				<br></br>
				<Row className="category" id="name">
					<Col md={2}>
						<label form="nameEntry">Name:</label>
					</Col>
					<Col>
						<input type="text" id="nameEntry" placeholder='Required' onChange={() => this.nameUpdate()} defaultValue=""/>
					</Col>
				</Row>
				<br></br>
				<Row className="category" id="intent">
					<Col md={2}>
						<label form="intentRadio">Intent:</label>
					</Col>
					<Col>
						<RadioOptions
							options={this.state.intent}
							update = {(intent) => this.changeIntent(intent)}
							name="intentRadio"
							default={this.state.intentValue}
							operations={this.props.operations}
						/>
					</Col>
				</Row>
				<br></br>
				<Row className="category" id="format">
					<Col md={2}>
						<label form="formatRadio">Format:</label>
					</Col>
					<Col>
						<RadioOptions
							options={this.state.format}
							update = {(format) => this.changeFormat(format)}
							name="formatRadio"
							default={this.state.formatValue}
						/>
					</Col>
				</Row>
				<br></br>
				<Row className="category" id="commit">
					<Col md={2}>
						<label form="commitRadio">Commit:</label>
					</Col>
					<Col>
						<RadioOptions
							options={this.state.commit}
							update = {(commit) => this.changeCommit(commit)}
							name="commitRadio"
							default={this.state.commitValue}
							intent={this.state.intentValue}
						/>
					</Col>

				</Row>
				<br></br>
				<Row className="category" id="script">
					<Col md={2}>
						<label form="scriptRadio">Script:</label>
					</Col>
					<Col>
						<RadioOptions
							options={this.state.script}
							update = {
								(script) => this.scriptChange(script)}
							name="scriptRadio"
							default={this.state.scriptValue}
						/>
					</Col>
				</Row>
				<Row className="category" id="script-options">
					<Col md={9} mdOffset={2} style={{paddingLeft:"0px"}}>
						<div id="script-types" style={{visibility: "hidden"}}>
							<label form="All" className="script-options-label">
								<input type="checkbox" value="All" id="All" className="script-type-option" onChange={() => this.updateScriptOptions("All", document.getElementById("All").checked)}/>
								All
							</label>
							<label form="onRow" className="script-options-label">
								<input type="checkbox" value="onRow" id="onRow" className="script-type-option" onChange={() => this.updateScriptOptions("onRow", document.getElementById("onRow").checked)}/>
								onRow
							</label>
							<label form="onRowsFinished" className="script-options-label">
								<input type="checkbox" value="onRowsFinished" id="onRowsFinished" className="script-type-option" onChange={() => this.updateScriptOptions("onRowsFinished", document.getElementById("onRowsFinished").checked)}/>
								onRowsFinished
							</label>
							<label form="onCommit" className="script-options-label">
								<input type="checkbox" value="onCommit" id="onCommit" className="script-type-option" onChange={() => this.updateScriptOptions("onCommit", document.getElementById("onCommit").checked)}/>
								onCommit
							</label>
						</div>
					</Col>
				</Row>
				<br></br>
			</div>
		);

	}
}

export default OptionSelector;